import { Button, Form, Radio, Stepper, TextArea, Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import axiosInstance from "../common/api";
import dayjs from "dayjs";
import { requiredField } from "../common/common";
import CalendarPicker from "./CalendarPicker";

export default function () {
    const [form] = Form.useForm();
    const [sp, setSP] = useSearchParams();
    const [invalid, setInvalid] = useState(true);
    const duration = Form.useWatch("duration", form);
    const justificationTypeId = Form.useWatch("justificationTypeId", form);
    const [loading, setLoading] = useState(false);
    const { kioskId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const mode = sp.get("mode");
        if (!mode) setInvalid(true);
        else if (mode === "kiosk" && !sp.get("badgeId")) setInvalid(true);
        else if (mode === "otp" && !sp.get("token")) setInvalid(true);
        else setInvalid(false);
    }, []);

    useEffect(() => {
        form.resetFields(["dates", "hours"]);
    }, [duration]);

    useEffect(() => {
        form.resetFields(["duration", "dates", "hours", "requestReason"]);
    }, [justificationTypeId]);

    const onFinish = (data) => {
        setLoading(true);
        axiosInstance
            .post("leaveRequest", {
                ...data,
                startDate: data.dates[0],
                endDate: data.dates[1] ?? data.dates[0],
                badgeId: sp.get("badgeId"),
                kioskId,
            })
            .then(() => {
                navigate("../leaveRequestFormSent", { replace: true });
            })
            .finally(() => setLoading(false));
    };

    if (invalid) return "";

    return (
        <div style={{ padding: 16 }}>
            <div style={{ textAlign: "end" }}>
                <Button
                    color="danger"
                    size="large"
                    onClick={() => navigate("../leaveRequestWait", { replace: true })}
                >
                    Annulla
                </Button>
            </div>
            <Form
                form={form}
                onFinish={onFinish}
                footer={
                    <Button
                        style={{ marginTop: 70 }}
                        block
                        type="submit"
                        color="primary"
                        size="large"
                        loading={loading}
                    >
                        Invia
                    </Button>
                }
            >
                <Form.Header>Modulo di richiesta permessi o ferie</Form.Header>
                <Form.Item name={"justificationTypeId"} label="Tipologia" rules={[requiredField]}>
                    <Radio.Group>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                columnGap: 24,
                                rowGap: 16,
                                flexWrap: "wrap",
                            }}
                        >
                            <Radio value={"P"}>Permesso</Radio>
                            <Radio value={"F"}>Ferie</Radio>
                        </div>
                    </Radio.Group>
                </Form.Item>
                {justificationTypeId && (
                    <Form.Item name={"duration"} label="Durata" rules={[requiredField]}>
                        <Radio.Group>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    columnGap: 24,
                                    rowGap: 16,
                                    flexWrap: "wrap",
                                }}
                            >
                                {justificationTypeId === "P" && (
                                    <Radio value={"hours"}>Meno di un giorno (ore)</Radio>
                                )}
                                <Radio value={"day"}>Un giorno</Radio>
                                <Radio value={"multi"}>Più di un giorno</Radio>
                            </div>
                        </Radio.Group>
                    </Form.Item>
                )}
                {duration && (
                    <Form.Item
                        name={"dates"}
                        label={duration === "multi" ? "Date" : "Data"}
                        rules={[requiredField]}
                    >
                        <CalendarPicker
                            minDate={dayjs().add(1, "day").format("YYYY-MM-DD")}
                            type={duration === "multi" ? "multi" : "single"}
                        />
                    </Form.Item>
                )}
                {duration === "hours" && justificationTypeId === "P" && (
                    <Form.Item name={"hours"} label="Ore" rules={[requiredField]} initialValue={1}>
                        <Stepper
                            min={1}
                            max={8}
                            inputReadOnly
                            style={{
                                "--height": "40px",
                                "--input-width": "100px",
                            }}
                        />
                    </Form.Item>
                )}
                {duration && justificationTypeId === "P" && (
                    <Form.Item name={"requestReason"} label="Motivazione" rules={[requiredField]}>
                        <TextArea
                            rows={4}
                            placeholder="Descrivere la motivazione in caso di permesso"
                        />
                    </Form.Item>
                )}
            </Form>
        </div>
    );
}
